import { CampusMap } from '../sections/campusMap'

const SELECTORS = Selectors({
  mapPanel: 'element-campusmap'
})

const $mapPanels = document.querySelectorAll(SELECTORS.asClass('mapPanel'))

const fn = {
  init: () => {
    CampusMap.setupMapAutocomplete(true)
  }
}

export default {
  can: () => $mapPanels.length,
  run: fn.init
}
